import { RouteObject } from "react-router-dom";
import LoginPage from "../Pages/login";
import Logout from "../Pages/logout";

export const insecureRoutes: RouteObject[] = [
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/",
    element: <LoginPage />,
  },
];
